import { useEventCommonStore, useEventStore, useUserStore } from '@/stores';
import { watch } from 'vue';

let isInitalized = false;
/**
 * Sets the window title based on the current event.
 *
 * TODO: Add current view/tab in the title?
 */
export const useWindowTitleSetter = () => {
    if (isInitalized) {
        // Is this a composable then?
        throw new Error('Window Title Setter should only be initalized once.');
    }

    isInitalized = true;

    const initialize = async () => {
        const eventStore = useEventStore();
        await eventStore.initpromise;

        watch(
            () => eventStore.eventID,
            async (newEventID) => {
                if (!newEventID) {
                    document.title = 'EQ Manager';
                    return;
                }

                const userStore = useUserStore();

                // If we arent logged in, trying to load the event will create a "NotLoggedIn" error, that will reload the page
                // So if we dont have this, the loginpage goes in infinite reload loop :)
                if (!userStore.user) {
                    document.title = 'EQ Manager';
                    return;
                }

                const eventCommonStore = useEventCommonStore();

                await eventCommonStore.EnsureLoaded(['Event']);
                const event = eventCommonStore.Event;

                if (!event) {
                    // Something has gone terribly wrong if we dont have an event here
                    document.title = 'EQ Manager';
                    return;
                }

                document.title = `EQ Manager - ${event.Name}`;
            },
        );
    };

    initialize();
};
